import { memberEditorViewState } from "..";
import { action } from "satcheljs/lib/legacy";
import { IMemberEntity } from "sh-models";

/**
 * Action to set the currently selected team members on the view state (this happens as part of add member to group flow)
 * @param {IMemberEntity} members - the team members that the user has currently selected from the name picker
 */
export default action("setCurrentlySelectedTeamMembers")(
    function setCurrentlySelectedTeamMembers(members: IMemberEntity[]) {
      memberEditorViewState().currentlySelectedTeamMembers = members;
    }
);